"use client";

import { ScreenOverlay, getCSSVar, useKeydown } from "@tosize/ui";
import { FocusTrap } from "focus-trap-react";
import { AnimatePresence, motion } from "motion/react";
import { Portal } from "radix-ui";
import type { ReactNode } from "react";
import { RemoveScroll } from "react-remove-scroll";
import { usePathnameChange } from "~/hooks/useRouteChange";

export interface DropProps {
	offsetTop: number;
	open: boolean;
	closeAction: () => void;
	children: ReactNode;
}

export function Drop({ offsetTop, open, closeAction, children }: DropProps) {
	useKeydown(closeAction);
	usePathnameChange(closeAction);

	return (
		<AnimatePresence>
			{open && (
				<Portal.Root>
					<ScreenOverlay variant="animated" onClick={closeAction} />
					<motion.div
						className="fixed top-0 right-0 left-0 z-dialog w-full bg-shades-light shadow"
						initial={{ y: offsetTop, opacity: 0 }}
						animate={{ y: getCSSVar("--header-y") + offsetTop, opacity: 1 }}
						exit={{ y: offsetTop, opacity: 0 }}
						transition={{ duration: 0.15, type: "tween" }}
					>
						<RemoveScroll enabled={open}>
							<FocusTrap active={open}>{children}</FocusTrap>
						</RemoveScroll>
					</motion.div>
				</Portal.Root>
			)}
		</AnimatePresence>
	);
}
